<form [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">Cambiar Contraseña</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <!-- <div class="form-group col-md-12">
        <label for="contrasenaAnterior">Contraseña Actual</label>
        <div class="input-group">
          <input [type]="(showOldPassword) ? 'text' : 'password'" class="form-control" id="contrasenaAnterior"
            formControlName="contrasenaAnterior"
            [ngClass]="{ 'is-invalid': submitted && form.controls.contrasenaAnterior.errors }">
          <div class="input-group-append">
            <div class="input-group-text showHidePass" (click)="showHideOldPassword()">
              <span [ngClass]="(showOldPassword) ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </div>
          </div>
          <div *ngIf="submitted && form.controls.contrasenaAnterior.errors" class="invalid-feedback">
            <div *ngIf="form.controls.contrasenaAnterior.errors.required">Campo requerido</div>
            <div *ngIf="form.controls.contrasenaAnterior.errors.confirmedValidator">Su contraseña no coincide con la
              actual
            </div>
          </div>
        </div>
      </div> -->

      <div class="form-group col-md-12">
        <label for="contrasenaNueva">Nueva Contraseña</label>
        <div class="input-group">
          <input [type]="(showNewPassword) ? 'text' : 'password'" class="form-control" id="contrasenaNueva"
            formControlName="contrasenaNueva"
            [ngClass]="{ 'is-invalid': submitted && form.controls.contrasenaNueva.errors }">
          <div class="input-group-append">
            <div class="input-group-text showHidePass" (click)="showHideNewPassword()">
              <span [ngClass]="(showNewPassword) ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </div>
          </div>
          <div *ngIf="submitted && form.controls.contrasenaNueva.errors" class="invalid-feedback">
            <div *ngIf="form.controls.contrasenaNueva.errors.required">Campo requerido</div>
            <div *ngIf="form.controls.contrasenaNueva.errors.distinctValidator">Su contraseña no puede ser la misma que
              la
              actual</div>
          </div>
        </div>
      </div>

      <div class="form-group col-md-12">
        <label for="contrasenaConfirmacion">Confirmar Contraseña</label>
        <div class="input-group">
          <input [type]="(showConfirmPassword) ? 'text' : 'password'" class="form-control" id="contrasenaConfirmacion"
            formControlName="contrasenaConfirmacion"
            [ngClass]="{ 'is-invalid': submitted && form.controls.contrasenaConfirmacion.errors }">
          <div class="input-group-append">
            <div class="input-group-text showHidePass" (click)="showHideConfirmPassword()">
              <span [ngClass]="(showConfirmPassword) ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
            </div>
          </div>
          <div *ngIf="submitted && form.controls.contrasenaConfirmacion.errors" class="invalid-feedback">
            <div *ngIf="form.controls.contrasenaConfirmacion.errors.required">Campo requerido</div>
            <div *ngIf="form.controls.contrasenaConfirmacion.errors.confirmedValidator">La contraseña y la confirmación
              de
              contraseña deben coincidir</div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer full-width col-md-12">
      <div class="col-md-12 text-center">
        <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
          <i class="fa fa-times-circle"></i>
          Cancelar
        </button>
        <button type="submit" class="btn btn-success btn-fidelis col-md-4">
          <i class="fa fa-check-circle"></i>
          Aceptar
        </button>
      </div>
    </div>

  </div>
</form>